import type { ContratApprentissageDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import { type TypeContextCourant } from '@/features/auth/context-app'
import type { NaturesFichierProvider } from '@/features/domaine/types//opco/Demande/shared'
import { isAdherentOuMandatGestion } from '../shared'
import { getAge, isDate } from '@/features/shared/tools'
import { getEstMajeurOuMineurEmancipe } from '@/features/domaine/regles-akto/CAPP/tools.ts'

export const NATURE_CAPP = 'NATURE_CAPP' as const
export const naturesFichiersCapp: NaturesFichierProvider<ContratApprentissageDTO> = {
  getNaturesFichiers: (demande: ContratApprentissageDTO, typeContext: TypeContextCourant) => {
    let obligatoires = ['Cerfa', 'Convention']
    let facultatifs = ['ConventionTripartite', 'Autre']
    const secondRepresentantLegal = "SecondRepresentantLegal" as const
    const justificatifCreationRepriseEntreprise = "JustificatifCreationRepriseEntreprise" as const

    const estAdherentOuMandatGestion = isAdherentOuMandatGestion(typeContext, demande.estSousMandatGestion ?? false)
    if (estAdherentOuMandatGestion) {
      facultatifs.push('Rupture')
    }

    // PRT-667 Second représentant légal
    const estMajeurOuMineurEmancipé = getEstMajeurOuMineurEmancipe({
      dateNaissance: demande.apprenti?.dateNaissance,
      dateConclusion: demande.contrat?.dateConclusion,
      mineurEmancipe: demande.representantLegal?.mineurEmancipe,
    })
    if (!estMajeurOuMineurEmancipé) {
      facultatifs.push(secondRepresentantLegal)
    }

    // PRT-668 Création ou reprise entreprise
    if (estAdherentOuMandatGestion && demande.apprenti?.projetCreationOuReprise) {
      const dérogations = ['AgeSuperieur29', 'CumulDerogations', 'AutreDerogation']
      if (dérogations.includes(demande.contrat?.typeDerogation ?? '') &&
          isDate(demande.apprenti?.dateNaissance) &&
          isDate(demande.contrat?.dateConclusion)) {
        const age = getAge(new Date(demande.apprenti.dateNaissance), new Date(demande.contrat.dateConclusion))
        if (age > 29) {
          obligatoires.push(justificatifCreationRepriseEntreprise)
        }
      }
    }

    let facultatifsDefaut: string[] = []

    if (!estAdherentOuMandatGestion) {
      facultatifs = [...obligatoires, ...facultatifs]
      facultatifsDefaut = [...obligatoires, ...facultatifsDefaut]
      obligatoires = []
    }

    return {
      obligatoires,
      facultatifs,
      facultatifsDefaut,
      /* Si absent, prend valeur par défaut. Peut-être calculé. Exemple :
          {
              'Cerfa': 10,
              'Convention': 2
          }
      */
      nombreFichiersMaximum: {},
      nombreFichiersMinimum: {},
    }
  },
  key: NATURE_CAPP,
}
